import type { LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

import styles from './StatePanel.module.css';

export interface EmptyStateProps {
    icon?: LucideIcon | undefined;
    title: string;
    description?: string | undefined;
    /** Optional actions. Only pass controls that do something. */
    action?: ReactNode;
}

export function EmptyState({
    icon: Icon,
    title,
    description,
    action,
}: EmptyStateProps): ReactElement {
    return (
        <div className={styles.panel}>
            {Icon ? (
                <span className={styles.icon} aria-hidden="true">
                    <Icon size={28} strokeWidth={1.75} />
                </span>
            ) : null}
            <p className={styles.title}>{title}</p>
            {description !== undefined ? <p className={styles.description}>{description}</p> : null}
            {action !== undefined ? <div className={styles.action}>{action}</div> : null}
        </div>
    );
}
